// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2G-IT","consentsList":"PatientConsents_consentsList__3bO_L","consentsListEmpty":"PatientConsents_consentsListEmpty__1aoGY"};